import React from 'react'
import CommonPopup from 'components/ui-kit/CommonPopup/index'
import { MetaMaskIconNewIcon, PhantomIconNewIcon } from 'components/ui-kit/Icons/svg/index'

const ICONS = {
  metamask: MetaMaskIconNewIcon,
  phantom: PhantomIconNewIcon
}

const WalletStatusPopup = ({ wallet, status, onClose, onRetry }) => {
  const Icon = ICONS[wallet] || PhantomIconNewIcon
  const isCancelled = status === 'cancelled'
  const isPending = status === 'pending'
  const displayName = wallet ? wallet.charAt(0).toUpperCase() + wallet.slice(1) : 'Wallet'

  return (
    <CommonPopup modalCloseHandler={onClose} hideCloseButton 
    modalDialogClass='!max-w-[400px]'
    >
      <div className='relative w-full text-white pt-1 pb-2 px-1'>
        <div className='relative flex items-center justify-center pb-2'>
          <button
            type='button'
            onClick={onClose}
            aria-label='Close'
            className='absolute left-0 top-0 flex h-7 w-7 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-white/10 hover:text-white'
          >
            <svg className='h-4 w-4' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'>
              <path d='M15 18l-6-6 6-6' />
            </svg>
          </button>
          <h4 className='m-0 text-base font-bold tracking-tight text-white'>{displayName}</h4>
        </div>

        <div className='relative mx-auto my-6 flex h-20 w-20 items-center justify-center rounded-2xl bg-[#262c36] p-3.5 shadow-inner'>
          <Icon className='h-11 w-11' />
          {isPending
            ? (
              <div className='absolute -bottom-1 -right-1 flex h-6 w-6 items-center justify-center rounded-full border border-gray-700 bg-[#191d24]'>
                <svg className='h-3.5 w-3.5 animate-spin text-amber-400' viewBox='0 0 24 24' fill='none'>
                  <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4' />
                  <path className='opacity-75' fill='currentColor' d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z' />
                </svg>
              </div>
              )
            : (
              <button
                type='button'
                onClick={onRetry}
                title='Try again'
                className='absolute -bottom-1 -right-1 flex h-6 w-6 items-center justify-center rounded-full border border-gray-600 bg-[#2b313d] text-gray-300 transition-colors hover:bg-gray-700 hover:text-white'
              >
                <svg className='h-3.5 w-3.5' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'>
                  <path d='M4 4v6h6M20 20v-6h-6M4 10a8 8 0 0114-4.9M20 14a8 8 0 01-14 4.9' />
                </svg>
              </button>
              )}
        </div>

        {/* Status Messages */}
        <div className='text-center'>
          {isCancelled
            ? (
              <>
                <h5 className='m-0 mb-1.5 text-base font-extrabold text-red-500'>Request Cancelled</h5>
                <p className='m-0 text-xs font-medium text-gray-400'>You cancelled the request. Please try again.</p>
              </>
              )
            : isPending
              ? (
                <>
                  <h5 className='m-0 mb-1.5 text-base font-bold text-white'>Connecting...</h5>
                  <p className='m-0 text-xs font-medium text-gray-400'>Confirm the connection request in your wallet.</p>
                </>
                )
              : (
                <>
                  <h5 className='m-0 mb-1.5 text-base font-extrabold text-red-500'>Connection Failed</h5>
                  <p className='m-0 text-xs font-medium text-gray-400'>Failed to connect to {displayName}. Please try again.</p>
                </>
                )}
        </div>
      </div>
    </CommonPopup>
  )
}

export default WalletStatusPopup
